<template>
    <!-- Comapny Communication Tab Content View From Company Profile -->
    <div class="tabs-content-firstblock">
        <div class="row">
            <div class="col-lg-12">
                <div class="infoHeader ml-2 mr-1">
                    <div class="descriptionheader">
                        <div class="description-text-header-left col-md-10">
                            <h5>
                                <i class="crmnew-phone iconsize-16 pr-2 defaultBlue"></i>
                                <!-- <img class="activityContact pr-2" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/crm/icons/communication.svg"> -->
                                Communication Information
                            </h5>
                        </div>
                        <a
                            href="javascript:;"
                            class="btn btn-secondary btn-smm  pull-right col-md-2"
                            v-on:click="editCompanyProfile()"
                        >
                            <i class="icon-pencil pr-1" style="font-size: 16px;"></i>
                            Edit
                        </a>
                        <!-- <div class="description-text-header-right">
                            <i class="icon icon-pencil"></i>
                        </div> -->
                    </div>
                </div>
                <!-- <div class="header-inline">
                    <div class="headerTitleView ml-8">
                        <span class="fs-14 defaultBlue aboutHeading">Communication Information</span>
                    </div>
                    <span class="header-inline-edit">
                        <i class="icon icon-pencil"></i>
                    </span>
                </div> -->
                <div class="ml-2 mr-1 mb-3">
                    <div class="a-q-Jc-j-contactView mt-1">
                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                            <div class="a-q-Jc-bj-contactView">Primary Email</div>
                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                <span class="a-q-Jc-wg-contactView font-color">
                                    {{ companyData.primary_email || '-' }}
                                </span>
                            </div>
                        </div>
                    </div>  
                    <div class="a-q-Jc-j-contactView mt-1" v-for="(email, index) in companyData.email" :key="index">
                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                            <!-- <div class="a-q-Jc-bj-contactView">{{email.email_type}} Email</div> -->
                            <div class="a-q-Jc-bj-contactView">Alternate Email - {{index+1}}</div>
                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                <span class="a-q-Jc-wg-contactView font-color">
                                    {{email.email_id || '-' }}
                                </span>
                            </div>
                        </div>
                    </div> 
                    <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                            <div class="a-q-Jc-bj-contactView">Primary Phone Number</div>
                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                <span class="a-q-Jc-wg-contactView" v-if="companyData.primary_phone">
                                    {{ companyData.primary_phone.phone_number || '-' }}
                                </span>
                                <span class="a-q-Jc-wg-contactView" v-else>
                                    -
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="a-q-Jc-j-contactView" v-for="(phone, index) in companyData.phone_details" :key="index">
                        <div class="a-q-Jc-Pj-Ya-contactView new-contactView">
                            <!-- <div class="a-q-Jc-bj-contactView">{{ phone.phone_type}} Number</div> -->
                            <div class="a-q-Jc-bj-contactView">Alternate Phone Number - {{index+1}}</div>
                            <div class="a-q-Jc-Lb-contactView new-contactView-item">
                                <span class="a-q-Jc-wg-contactView">
                                    {{ phone.phone_number || '-' }}
                                </span>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView">
                            <div class="a-q-Jc-bj-contactView">Website Address</div>
                            <div class="a-q-Jc-Lb-contactView">
                                <span class="a-q-Jc-wg-contactView text-runcate">
                                    {{ companyData.website || '-' }}
                                </span>
                            </div>
                        </div>
                    </div> -->
                    <!-- <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView">
                        <div class="a-q-Jc-bj-contactView">Emergency Contact Name</div>
                        <div class="a-q-Jc-Lb-contactView">
                            <span class="a-q-Jc-wg-contactView">
                            {{ companyData.emergency.emergency_contact_name }}
                            </span>
                        </div>
                        </div>
                    </div> -->
                    <!-- <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView">
                        <div class="a-q-Jc-bj-contactView">Relationship</div>
                        <div class="a-q-Jc-Lb-contactView">
                            <span class="a-q-Jc-wg-contactView">
                            Brother
                            </span>
                        </div>
                        </div>
                    </div> -->
                    <!-- <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView">
                        <div class="a-q-Jc-bj-contactView">Emergency Contact Number</div>
                        <div class="a-q-Jc-Lb-contactView">
                            <span class="a-q-Jc-wg-contactView">
                            {{ companyData.emergency.emergency_contact_number.phone_number }}
                            </span>
                        </div>
                        </div>
                    </div> -->
                    <!-- <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView">
                        <div class="a-q-Jc-bj-contactView">Medical Emergency Notes </div>
                        <div class="a-q-Jc-Lb-contactView">
                            <span class="a-q-Jc-wg-contactView">
                            Allegeric with Cold Temperature
                            </span>
                        </div>
                        </div>
                    </div> -->
                    <!-- <div class="a-q-Jc-j-contactView">
                        <div class="a-q-Jc-Pj-Ya-contactView" style="border-bottom: solid 1px transparent !important;">
                        <div class="a-q-Jc-bj-contactView">Social Media</div>
                        <div class="a-q-Jc-Lb-contactView" style="padding: 17px 0px;">
                            <span class="a-q-Jc-wg-contactView" v-for="(media, index) in companyData.social_media" :key="index">
                                <span v-if="media.account_type=='Facebook' && media.account_url.length">
                                    <a :href="media.account_url" target="_blank" style="text-decoration: none !important;" :title="media.account_url">
                                        <i class="icon icon-facebook defaultBlue mediaFacebook" style="font-size: 22px;width: 16px;height: 16px;line-height: 16px;" ></i>
                                    </a>
                                </span>
                                <span v-if="media.account_type=='Twitter' && media.account_url.length">
                                    <a :href="'http://'+media.account_url" target="_blank" style="text-decoration: none !important;" :title="media.account_url">
                                        <i class="icon icon-twitter defaultBlue mediaTwitter ml-2" style="font-size: 22px;width: 16px;height: 16px;line-height: 16px;" v-if="media.account_url.length"></i>
                                    </a>
                                </span>
                                <span v-if="media.account_type=='Skype' && media.account_url.length">
                                    <a :href="media.account_url" target="_blank" style="text-decoration: none !important;" :title="media.account_url">
                                        <i class="icon icon-skype defaultBlue mediaSkype ml-2" style="font-size: 22px;width: 16px;height: 16px;line-height: 16px;" v-if="media.account_url.length"></i>
                                    </a>
                                </span>
                            </span>
                        </div>
                        </div>
                    </div> -->
                </div>
            </div>    
        </div>
    </div>
</template>
<script>
export default {
  props: ["companyData"],
  methods: {
    editCompanyProfile() {
      this.$router.push({
        name: "EditCompanyProfile",
        params: { id: this.$route.params.id },
      });
    },
  }
};
</script>
<style scoped>
    .new-contactView-item{
        padding: 16px 10px 16px 3px !important;
    }
    .new-contactView {
        display: flex;
        align-items: center;
    }
</style>




// WEBPACK FOOTER //
// src/components/CompanyCommunicationView.vue